var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('header-navigation'),_c('div',{staticClass:"container"},[_c('error',{ref:"error"})],1),_c('bottom-credits')],1)}
var staticRenderFns = []

export { render, staticRenderFns }